<div class="lvi-content">
    <div class="avatar" [ngClass]="{ 'warning': data.listeAlertes?.niveau == 1,'danger': data.listeAlertes?.niveau == 2 }">
        <i class="nio icon-note_de_frais"></i>
    </div>
    <div class="lvi-body">
        <div class="title">
            <a class="dashboard-list-title" [routerLink]="" (click)="navigateTo()">
                {{ data.numeroPiece || ('ndf.liste.numeroNonDefini' | translate) }} - {{ data.objet || ('ndf.liste.objetNonDefini' | translate) }}
            </a>
        </div>
        <ul class="lvi-attrs">
            <li><strong [translate]="'dashboard.listeNDF.montant'"></strong><span>{{ data.montantRemboursable | montant: data.devise.code }}</span></li>
        </ul>
    </div>
    <div class="info">
        <statut [statut]="data.statut" [isMinimized]="true"></statut>
    </div>
</div>
